<!-- 工作台 -->
<template>
  <div>
    <div class="form-main">
      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-width="120px"
        class="formData"
      >
        <div>
          <el-form-item label="联盟商品">
            {{ goodName }}
          </el-form-item>
          <el-form-item label="可售数量" prop="Count">
            <el-input-number
              v-model="formData.Count"
              :min="0"
              :step="1"
              style="width: 100%"
            ></el-input-number>
          </el-form-item>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="cancel()">关闭</el-button>
        <el-button class="btn-primary" @click="submitRoleForm">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["uGoods"],
  name: "",
  data() {
    return {
      formData: {
        UnionId: this.$util.getLocalStorage("currentUnion"),
        Count: 0,
        UGoodsId: "",
      },
      goodName: "",
    };
  },
  mounted() {
    if (this.uGoods) {
      this.formData.Count = this.uGoods.Inventory;
      this.formData.UGoodsId = this.uGoods.UGoodsId;
      this.goodName = this.uGoods.GoodName + "【 " + this.uGoods.APCode + " 】";
    }
  },
  methods: {
    // 提交表单
    submitRoleForm() {
      let that = this;
      let url = "/api/EntpUnionGoods/SubmitGoodsInvenData";
      that.$util
        .axiosPost({
          url: url,
          data: that.formData,
        })
        .then((res) => {
          that.$util.successMsg(res.errmsg);
          that.$emit("closeDialog", true);
        })
        .catch(() => {});
    },
    cancel() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style lang="less" scoped>
.form-value {
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  color: #606266;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  width: 100%;
}
.form-column {
  width: 33.33%;
}
.dialog-footer {
  text-align: right;
}
</style>
